/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { FractionDependencies } from './dependenciesFractionClass.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCompare } from '../../factoriesAny.js';
export var compareDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  DenseMatrixDependencies: DenseMatrixDependencies,
  FractionDependencies: FractionDependencies,
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createCompare: createCompare
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCompare.generated.js
// module id = 130
// module chunks = 0